/**
 * Implements a mobile pairs table section placeholder
 */
import Skeleton from 'react-loading-skeleton';

interface IPairsTablePlaceholderProps {
  title?: boolean;
}

const PairsTable = ({ title }: IPairsTablePlaceholderProps) => {
  return (
    <div className='mobile_seo_page__table'>
      {title && (
        <div className='mobile_seo_page__table__title'>
          <Skeleton width={142} height={24} />
        </div>
      )}
      <div className='mobile_seo_page__table__content'>
        <Skeleton height={58} count={5} />
      </div>
      <div
        className='mobile_seo_page__table__additional'
        style={{ width: '100%', display: 'block' }}
      >
        <Skeleton height={32} style={{ marginBottom: 20 }} />
        <Skeleton width={123} height={36} />
      </div>
    </div>
  );
};

export default PairsTable;
